export default function PianoAnalytics() {
  if (window.location.href.match(/:\/\/localhost/)) {
    return;
  }
  (function (_config) {
    var script = document.createElement("script");
    script.src = "https://tag.aticdn.net/piano-analytics.js";
    script.async = true;
    script.dataset.config = JSON.stringify(_config);
    document.head.appendChild(script);
  })({
    site: 647984,
    collectDomain: "https://wbxqmfl.pa-cd.com",
    instantTracking: true,
  });
}
